export default __webpack_public_path__ + "static/media/lid_hiswa.fba985dd.svg";